import Vuex from "vuex";
import portalStore from "@/views/store";
export default new Vuex.Store({
  modules: { portalStore },
});
